/**
 * Imperative handle the R3F scene exposes to the rest of the app (HUD buttons,
 * GAIA, the dive). Everything declarative goes through the twin store; this
 * covers the few things that need the live camera or the render loop.
 */
import type { CameraPose } from '../types';

export interface ScreenPoint {
  x: number;
  y: number;
  /** False when behind the camera or outside the viewport. */
  visible: boolean;
  /** Depth 0 to 1 for sorting leader labels. */
  depth: number;
}

export interface TwinHandle {
  /** Current camera as a pose (position, target, fov) in asset metres. */
  getCameraPose(): CameraPose;
  /** Frame the whole asset or one subsystem; resolves when the flight ends. */
  flyTo(target: { pose?: CameraPose; subsystemId?: string; poseId?: string }, durationMs?: number): Promise<void>;
  /** Screen position of a subsystem's centre for HTML labels and leader lines. */
  project(subsystemId: string): ScreenPoint | null;
  /** Subsystem ids the asset exposes (bound nodes found in the model). */
  boundSubsystemIds(): string[];
  /** Render on demand (parked) or continuously. */
  setFrameloop(mode: 'always' | 'demand'): void;
  /** PNG data URL of the current frame for reports. */
  snapshot(): string;
  /** Sun direction for the environment (azimuth and elevation in degrees). */
  setSun(azimuthDeg: number, elevationDeg: number): void;
}

let handle: TwinHandle | null = null;

export function setTwinHandle(h: TwinHandle | null): void {
  handle = h;
}

export function getTwinHandle(): TwinHandle | null {
  return handle;
}
